import * as ng from 'angular';
import * as Linq from 'linq-es5';
import { ComponentRegistration, ISiteConfigService } from '../../core';
import { ISessionService } from '../../services';
import { IUserResource } from './';
import { Dto } from '../../data';
let template = require('./reset-password.html');

class ResetPasswordComponent extends ComponentRegistration {

    constructor() {
        super('resetPassword', {
            controller: ResetPasswordController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
            }
        });
    }
}


interface IResetPasswordController {
    activate(): void;
    onSave(): ng.IPromise<any>;
}

class ResetPasswordController implements IResetPasswordController {
    private static $inject: Array<string> = ['$scope', '$rootRouter', '$location', '$timeout', 'User', 'Session', 'SiteConfig'];

    private request: any = {};
    private isAskQuestionStep: Boolean = false;
    private password: string = '';
    private token = (this.$location as any).$$search.token;
    private userId = (this.$location as any).$$search.uid;
    private successful: Boolean = false;
    private showError: Boolean = false;
    private errorMessage: string = '';
    private confirmPassword: string = '';
    private resetPasswordForm: ng.IFormController;
    private securityQuestionForm: ng.IFormController;
    private showQuestionCard: Boolean = false;

    constructor(private $scope: ng.IScope,
        private $router: ng.Router,
        private $location: ng.ILocationService,
        private $timeout: ng.ITimeoutService,
        private User: IUserResource,
        private Session: ISessionService,
        private SiteConfig: ISiteConfigService) {

        console.log('ResetPasswordController loaded');

        this.activate();

    }

    public activate(): void {

        console.log('ResetPasswordController activated');
    }

    // private members
    public onSave(): ng.IPromise<void> {

        if (this.resetPasswordForm.$valid) {

            var message = {
                password: this.password,
                resetToken: this.token
            } as Dto.IPasswordResetRequest;

            return this.User.resetPassword({ id: this.userId }, message).$promise
                .then((response) => {
                    let scope = this.SiteConfig.getClientByType("User").clientId;

                    this.Session.createSession({
                        scope: "HubUSA.ASM.Api",
                        username: response.username,
                        password: this.password
                    }).then((context) => {

                        this.showQuestionCard = !context.profile.securityQuestion;
                        if (!this.showQuestionCard) {
                            this.onQuestionSaved();
                        }
                    });

                }, (error) => {
                    if (error.status === 500)
                        this.errorMessage = 'Internal Server Error. Please try again later.';
                    else
                        this.errorMessage = 'Reset password link is invalid or has expired. Please use the forgot password button\nto request a new reset password link be sent by email or return to the main page.';
                    this.showError = true;
                })
                .catch((e) => {
                    //js exception caught
                    console.log("Failed save of reset failed");

                });
        }
    }

    //TODO: Testing purposes only, remove when completed.
    private onQuestionSaved(): void {
        this.successful = true;
        this.showQuestionCard = false;
        this.$timeout(() => {
            if (this.Session.isAdmin()) {
                this.$router.navigate(['Admin']);
            }
            else {
                this.$router.navigate(['Overview']);
            }

        },10000);
            
    }
}

let rstpwdComponent = new ResetPasswordComponent();
export default rstpwdComponent;
export { rstpwdComponent as ResetPasswordComponent, IResetPasswordController, ResetPasswordController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/security/reset-password.ts